import { render } from "./TopThreeExample.vue?vue&type=template&id=0d4da706"
import script from "./TopThreeExample.vue?vue&type=script&lang=js"
export * from "./TopThreeExample.vue?vue&type=script&lang=js"

import "./TopThreeExample.vue?vue&type=style&index=0&id=0d4da706&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__